export interface SessionData {
  isOverridden?: boolean | null | undefined
  name?: string | null | undefined
  sequence?: string | null | undefined
  fiveMod?: string | null | undefined
  purification?: string | null | undefined
  baseCount?: number | null | undefined
  format?: string | null | undefined
  concentration?: string | null | undefined
  tubes?: string | null | undefined
  price?: string | null | undefined
  scale?: string | null | undefined
  orderItemId?: string | null | undefined
  id?: string | null | undefined
  applyToAll?: boolean | null | undefined
  comments?: string | null | undefined
  additionalComments?: string | null | undefined
  senseNameCheck?: boolean | null | undefined
  plateType?: string | null | undefined
  packageType?: string | null | undefined
  oligoId?: number | null | undefined
  countryCode?: string | null | undefined
  autoValidation?: string | null | undefined
  productType?: string | null | undefined
  customerOverhang?: string | null | undefined
  antisenceName?: string | null | undefined
  antisenceSequence?: string | null | undefined
  autoGenerateOligo?: boolean | null | undefined
  customerAntisenseOverHang?: string | null | undefined
  antisenceThreeMod?: string | null | undefined
  antisenceFiveMod?: string | null | undefined
  threeMod?: string | null | undefined
  antisenceBaseCount?: number | null | undefined
  amount?: string | null | undefined
  listError: ListError[]
  currencySymbol?: string | null | undefined
  currency?: string | null | undefined
  cartId?: string | null | undefined
  itemId?: string | null | undefined
}

export interface SetSequenceData {
  sequenceData: string
  selectionData: string
  error: string
  position: number
  baseCount: number
  seqLength: number
}

export interface RuleValidationData {
  name: string
  sequence: string
  purification: string
  amount: string
  threeMod: string
  fiveMod: string
  scale: string
  format: string
  concentration: string
  tubes: string
  researcher: string
  countryCode: string
  isOverridden: boolean
  customerOverhang: string
  antisenceName: string
  antisenceSequence: string
  customerAntisenseOverHang: string
  antisenceBaseCount: number
  antisenceFiveMod: string
  antisenceThreeMod: string
  autoGenerateOligo: boolean
  senseNameCheck: boolean
}

export interface ProductInformationResponse {
  productType?: string | null | undefined
  typeCode?: string | null | undefined
  packageType?: string | null | undefined
  instructions?: string | null | undefined
  brand?: string | null | undefined
  shippingOptions?: any[] | null | undefined
  companionProducts?: any[] | null | undefined
  currencyFormat?: string
  decimalSeparator?: string
  thousandSeparator?: string
  prefixCurrecny?: boolean
  thousandSpacing?: string
}
export interface ListError {
  key?: string | null | undefined
  value?: string | null | undefined
}
export interface TubeTotalValidation {
  listErrors?: [ListError?]
}

export interface DuplexState {
  sessionData: SessionData[]
  errorData: RuleValidationData
  errorResponseJson: any
  seqLength: number
  antisenseSeqLength: number
  overriddenFlag: boolean
  overiddenNumber: number
  isSequenceValid: boolean
  isAntiSeqValid: boolean
  currentOligoIndex: number
  setSequenceData: SetSequenceData
  totalValidation: TubeTotalValidation[]
  callTotalValidation: boolean
  isValidTotalValidation: boolean
  index: number
  oligoCount: number
  isPageLoad: number
  specificationTotalValidation: boolean
  pageError: string
  OligoIndex: number
  stepNo: number
  hasReviewError: boolean
  countryCode: string
  addNewDuplex: boolean
  productInformation: ProductInformationResponse
  confirmOrder: boolean
  bulkReview: boolean
  deleteLastOligo: number
  itemValidation: boolean
  circuitBreak: boolean
  errorOnPageRefresh: boolean
  errorIconOnPageload: boolean
  senseValidation: boolean
  noContinueToNextPage: boolean
  onContinueButtonPriceCall: boolean
  pageReload: boolean
  callSessionAPI: boolean
  clearSessionData: boolean
  isDeleteAll: boolean
  isSideNavLinkDisabled: boolean
  specificationResponse: any
  deleteSelected: number
  validateOnClick: boolean
  isComingFromConfimPage: boolean
  isSessionLoaded: boolean
}

export const EmptyState = {
  isOverridden: false,
  name: '',
  sequence: '',
  fiveMod: '',
  purification: '',
  baseCount: 0,
  format: '',
  concentration: '',
  tubes: '1',
  price: '',
  scale: '',
  orderItemId: '',
  id: '1',
  comments: '',
  additionalComments: '',
  oligoId: 0,
  countryCode: '',
  autoValidation: '',
  productType: '',
  customerOverhang: '',
  antisenceName: '',
  antisenceSequence: '',
  autoGenerateOligo: false,
  customerAntisenseOverHang: '',
  antisenceBaseCount: 0,
  amount: '',
  senseNameCheck: false,
  antisenceThreeMod: '',
  antisenceFiveMod: '',
  threeMod: '',
  listError: [{ key: '', value: '' }],
  currencySymbol: '',
  currency: '',
  cartId: '',
  itemId: '',
}

export const initialState: DuplexState = {
  sessionData: [
    {
      isOverridden: false,
      name: '',
      sequence: '',
      fiveMod: '',
      purification: '',
      baseCount: 0,
      format: '',
      concentration: '',
      tubes: '1',
      price: '',
      scale: '',
      orderItemId: '',
      id: '1',
      comments: '',
      additionalComments: '',
      // fullSOligoBackbone: false,

      oligoId: 0,
      countryCode: '',
      autoValidation: 'false',
      productType: '',
      customerOverhang: '',
      antisenceName: '',
      antisenceSequence: '',
      autoGenerateOligo: false,
      customerAntisenseOverHang: '',
      antisenceBaseCount: 0,
      amount: '',
      senseNameCheck: false,
      listError: [{ key: '', value: '' }],
      currencySymbol: '',
      currency: '',
      antisenceThreeMod: '',
      antisenceFiveMod: '',
      threeMod: '',
    },
  ],
  errorData: {
    name: '',
    sequence: '',
    scale: '',
    purification: '',
    fiveMod: '',
    threeMod: '',
    researcher: '',
    format: '',
    concentration: '',
    tubes: '1',
    countryCode: '',
    customerOverhang: '',
    antisenceName: '',
    antisenceSequence: '',
    isOverridden: false,
    customerAntisenseOverHang: '',

    antisenceBaseCount: 0,
    amount: '',
    antisenceFiveMod: '',
    antisenceThreeMod: '',
    autoGenerateOligo: false,
    senseNameCheck: false,
  },
  errorResponseJson: {},
  seqLength: 0,
  antisenseSeqLength: 0,
  isSequenceValid: false,
  isAntiSeqValid: false,
  currentOligoIndex: 0, // index to manage standard datas
  setSequenceData: {
    sequenceData: '',
    selectionData: '',
    error: '',
    position: 0,
    baseCount: 0,
    seqLength: 0,
  },

  totalValidation: [],
  callTotalValidation: false,
  isValidTotalValidation: false,
  index: 0,
  oligoCount: 0,
  isPageLoad: 0,
  specificationTotalValidation: false,
  pageError: '',
  OligoIndex: 0,
  stepNo: 0,
  hasReviewError: false,
  overiddenNumber: 0,
  overriddenFlag: false,

  countryCode: '',
  addNewDuplex: false,
  productInformation: {
    productType: '',
    typeCode: '',
    packageType: '',
    instructions: '',
    brand: '',
    shippingOptions: [''],
    companionProducts: [''],
    currencyFormat: '',
    decimalSeparator: '',
    thousandSeparator: '',
    prefixCurrecny: true,
    thousandSpacing: '',
  },
  confirmOrder: false,
  bulkReview: false,
  deleteLastOligo: 0,
  itemValidation: false,
  circuitBreak: false,
  errorOnPageRefresh: false,
  errorIconOnPageload: false,
  senseValidation: false,
  noContinueToNextPage: false,
  onContinueButtonPriceCall: false,
  pageReload: false,
  callSessionAPI: false,
  clearSessionData: false,
  isDeleteAll: false,
  isSideNavLinkDisabled: false,
  specificationResponse: {},
  deleteSelected: 0,
  validateOnClick: false,
  isComingFromConfimPage: false,
  isSessionLoaded: false,
}

type Action =
  | { type: 'INIT' }
  | { type: 'UPDATE_INPUT'; data: SessionData[] }
  | { type: 'UPDATE_ERROR_DATA'; data: RuleValidationData }
  | { type: 'UPDATE_ERROR_RESPONSE'; data: any }
  | { type: 'UPDATE_SEQUENCE_LENGTH'; data: number }
  | { type: 'UPDATE_ANTISENSE_SEQUENCE_LENGTH'; data: number }
  | { type: 'UPDATE_VALID_SEQUENCE'; data: boolean }
  | { type: 'UPDATE_CURRENT_OLIGO_INDEX'; data: number }
  | { type: 'UPDATE_SET_SEQUENCE_DATA'; data: SetSequenceData }
  | { type: 'UPDATE_TOTALVALIDATION'; data: TubeTotalValidation[] }
  | { type: 'CALL_TOTAL_VALIDATION'; data: boolean }
  | { type: 'IS_VALID_TOTAL_VALIDATION'; data: boolean }
  | { type: 'SPECIFICATION_TOTAL_VALIDATION'; data: boolean }
  | { type: 'UPDATE_PAGE_LOAD'; data: number }
  | { type: 'ADD_NEW_OLIGO'; data: number }
  | { type: 'SET_PAGE_ERROR'; data: string }
  | { type: 'UPDATE_OLIGO_INDEX'; data: number }
  | { type: 'SET_STEP_NO'; data: number }
  | { type: 'HAS_REVIEW_ERROR'; data: boolean }
  | { type: 'HAS_OVERRIDDEN_FLAG'; data: boolean }
  | { type: 'COUNTRY_CODE'; data: string }
  | { type: 'UPDATE_VALID_ANTISEQ'; data: boolean }
  | { type: 'ADD_NEW_DUPLEX'; data: boolean }
  | { type: 'SET_PRODUCT_INFORMATION'; data: ProductInformationResponse }
  | { type: 'IS_CONFIRM_ORDER'; data: boolean }
  | { type: 'IS_BULK_REVIEW'; data: boolean }
  | { type: 'DELETE_LAST_OLIGO'; data: number }
  | { type: 'ITEM_VALIDATION'; data: boolean }
  | { type: 'OVERRIDDEN_NUMBER'; data: number }
  | { type: 'UPDATE_CIRCUIT_BREAK'; data: boolean }
  | { type: 'SET_ERROR_ON_PAGE_REFRESH'; data: boolean }
  | { type: 'SET_ERROR_ICON_ON_PAGELOAD'; data: boolean }
  | { type: 'SENSE_VALIDATION'; data: boolean }
  | { type: 'SET_CONTINUE_TO_NEXT_PAGE'; data: boolean }
  | { type: 'ON_CONTINUE_BUTTON_PRICECALL'; data: boolean }
  | { type: 'IS_PAGE_RELOAD'; data: boolean }
  | { type: 'CALL_SESSION_API'; data: boolean }
  | { type: 'CLEAR_SESSION_DATA'; data: boolean }
  | { type: 'IS_DELETE_ALL'; data: boolean }
  | { type: 'IS_SIDE_NAV_DISABLE'; data: boolean }
  | { type: 'UPDATE_SPECIFICATION_RESPONSE'; data: any }
  | { type: 'IS_DELETE_SELECTED'; data: number }
  | { type: 'VALIDATE_ON_CLICK'; data: boolean }
  | { type: 'IS_COMING_FROM_CONFIGM_PAGE'; data: boolean }
  | { type: 'IS_SESSION_LOADED'; data: boolean }
export interface ContextProps {
  bitubeState: DuplexState
  biTubeDispatch: ({ type, data }) => void
}

export function reducer(state: DuplexState, action: Action): DuplexState {
  const keys = {
    UPDATE_INPUT: 'sessionData',
    UPDATE_ERROR_DATA: 'errorData',
    UPDATE_ERROR_RESPONSE: 'errorResponseJson',
    OVERRIDDEN_NUMBER: 'overiddenNumber',
    UPDATE_SEQUENCE_LENGTH: 'seqLength',
    UPDATE_ANTISENSE_SEQUENCE_LENGTH: 'antisenseSeqLength',
    UPDATE_VALID_SEQUENCE: 'isSequenceValid',
    UPDATE_SET_SEQUENCE_DATA: 'setSequenceData',
    UPDATE_CURRENT_OLIGO_INDEX: 'currentOligoIndex',
    UPDATE_TOTALVALIDATION: 'totalValidation',
    CALL_TOTAL_VALIDATION: 'callTotalValidation',
    IS_VALID_TOTAL_VALIDATION: 'isValidTotalValidation',
    UPDATE_PAGE_LOAD: 'isPageLoad',
    ADD_NEW_OLIGO: 'oligoCount',
    SPECIFICATION_TOTAL_VALIDATION: 'specificationTotalValidation',
    SET_PAGE_ERROR: 'pageError',
    UPDATE_OLIGO_INDEX: 'OligoIndex',
    SET_STEP_NO: 'stepNo',
    HAS_REVIEW_ERROR: 'hasReviewError',
    HAS_OVERRIDDEN_FLAG: 'overriddenFlag',
    COUNTRY_CODE: 'countryCode',
    UPDATE_VALID_ANTISEQ: 'isAntiSeqValid',
    ADD_NEW_DUPLEX: 'addNewDuplex',
    SET_PRODUCT_INFORMATION: 'productInformation',
    IS_CONFIRM_ORDER: 'confirmOrder',
    IS_BULK_REVIEW: 'bulkReview',
    DELETE_LAST_OLIGO: 'deleteLastOligo',
    ITEM_VALIDATION: 'itemValidation',
    UPDATE_CIRCUIT_BREAK: 'circuitBreak',
    SET_ERROR_ON_PAGE_REFRESH: 'errorOnPageRefresh',
    SET_ERROR_ICON_ON_PAGELOAD: 'errorIconOnPageload',
    SENSE_VALIDATION: 'senseValidation',
    SET_CONTINUE_TO_NEXT_PAGE: 'noContinueToNextPage',
    ON_CONTINUE_BUTTON_PRICECALL: 'onContinueButtonPriceCall',
    IS_PAGE_RELOAD: 'pageReload',
    CALL_SESSION_API: 'callSessionAPI',
    CLEAR_SESSION_DATA: 'clearSessionData',
    IS_DELETE_ALL: 'isDeleteAll',
    IS_SIDE_NAV_DISABLE: 'isSideNavLinkDisabled',
    UPDATE_SPECIFICATION_RESPONSE: 'specificationResponse',
    IS_DELETE_SELECTED: 'deleteSelected',
    VALIDATE_ON_CLICK: 'validateOnClick',
    IS_COMING_FROM_CONFIGM_PAGE: 'isComingFromConfimPage',
    IS_SESSION_LOADED: 'isSessionLoaded',
  }

  if (keys[action.type] && action.type !== 'INIT') {
    const newState = { ...state }
    newState[keys[action.type]] = action.data
    return newState
  } else {
    return initialState
  }
}
